"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript = void 0;
const __1 = require("../..");
const Damage_1 = require("../../core/Damage");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const __2 = require("../..");
let Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript = class Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.EffectApplied) {
            return;
        }
        const effectApplied = container.getEffect(event.args.effectId);
        if (effectApplied.args.__type !== EffectType_1.EffectType.Healing) {
            return;
        }
        if (container.isDeceased(event.subject)) {
            return;
        }
        sequence.push(new core_1.InstantVfxStepArgs(new __2.ActorVfxLocationSelector(event.subject, "chest"), "FaintFire"));
        const args = effectApplied.args;
        container.applyExactDamage({
            attackerId: handler.args.scriptArgs.attackerId,
            targetId: event.subject,
            damage: new Damage_1.Damage(__1.DamageType.Fire, args.amount),
            sequence: sequence.pushSequence("sequential"),
        });
    }
};
Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Meltdown_OnHealingEffectApplied")
], Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript);
exports.Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript = Effect_Meltdown_OnHealingEffectAppliedEventHandlerScript;
